<template>
  <v-row>
    <v-col cols="12" v-if="selectedProfile == null">
      <v-row justify="end">
        <v-btn class="ma-2" @click="addProfile" color="success" small dark>
          create new profile
          <v-icon right dark>add</v-icon>
        </v-btn>
        <v-btn class="ma-2" @click="importProfile" color="success" small dark>
          import profile
          <v-icon right dark>cloud_upload</v-icon>
        </v-btn>
      </v-row>
    </v-col>
    <v-col cols="12" v-if="!profiles || !profiles.length">
      <v-alert v-if="loading" :value="true" type="info">Loading profiles..</v-alert>
      <v-alert v-else :value="true" type="warning">No profiles configured!</v-alert>
    </v-col>
    <v-col cols="12" v-if="!selectedProfile && profiles">
      <v-container class="grid-list" fluid>
        <v-row>
          <v-col
            class="d-flex child-flex"
            v-for="profile in profiles"
            :key="profile.id"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card
              class="flexcard"
              style="display:flex;flex-direction:column;"
              height="100%"
              :dark="darkBackgroundColors.includes(profile.color) ? false : true"
              :color="profile.color"
            >
              <v-card-title>
                <v-icon large left>{{profile.icon}}</v-icon>
                <span class="title font-weight-light">{{profile.name}}</span>
              </v-card-title>
              <v-card-text class="grow">{{profile.description}}</v-card-text>
              <v-card-actions>
                <v-row align="end" justify="end">
                  <v-btn class="ma-2" icon color="white" @click="selectedProfile = profile">
                    <v-icon color="primary-dark">edit</v-icon>
                  </v-btn>
                  <v-btn class="ma-2" icon color="white" @click="exportProfile(profile.id)">
                    <v-icon color="primary-dark">cloud_download</v-icon>
                  </v-btn>
                  <v-btn class="ma-2" icon color="white" @click="removeProfile(profile.id)">
                    <v-icon color="error">delete</v-icon>
                  </v-btn>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
    <v-col cols="12">
      <identityProfileForm
        v-if="selectedProfile != null"
        :profile="selectedProfile"
        v-on:done="selectedProfile = null"
        v-on:reset="getProfiles"
      ></identityProfileForm>
    </v-col>
  </v-row>
</template>

<script>
import identityProfileForm from "../../components/IdentityProfileForm.vue";
export default {
  name: "IdentityProfile",
  components: {
    identityProfileForm
  },
  data() {
    return {
      loading: true,
      selectedProfile: null,
      profiles: [],
      darkBackgroundColors: ["white", "yellow", "lime"]
    };
  },
  methods: {
    parseUploadedProfile(val) {
      delete val.id;
      delete val.created;
      delete val.identities;
      delete val.identityProfileAssetProfiles;
      delete val.identityProfileOrganizationProfiles;
      delete val.identityProfileUsers;
      delete val.modified;
      delete val.modifiedBy;
      delete val.modifiedById;
      delete val.order;
      if (val.steps) {
        val.steps.forEach(s => {
          delete s.id;
          delete s.created;
          delete s.modified;
          delete s.modifiedBy;
          delete s.modifiedById;
          delete s.order;
          delete s.profileId;
          if (s.fields) {
            s.fields.forEach(f => {
              delete f.id;
              delete f.created;
              delete f.modified;
              delete f.modifiedBy;
              delete f.modifiedById;
              delete f.order;
              delete f.stepId;
              if (f.items) {
                f.items.forEach(i => {
                  delete i.id;
                  delete i.created;
                  delete i.modified;
                  delete i.modifiedBy;
                  delete i.modifiedById;
                  delete i.order;
                  delete i.fieldId;
                });
              }
            });
          }
        });
      }
      if (val.apiKeys) {
        val.apiKeys.forEach(a => {
          delete a.id;
          delete a.created;
          delete a.modified;
          delete a.modifiedBy;
          delete a.modifiedById;
          delete a.profileId;
        });
      }
      if (val.triggers) {
        val.triggers.forEach(t => {
          delete t.id;
          delete t.created;
          delete t.modified;
          delete t.modifiedBy;
          delete t.modifiedById;
          delete t.order;
          delete t.profileId;
          if (t.actions) {
            t.actions.forEach(a => {
              delete a.id;
              delete a.created;
              delete a.modified;
              delete a.modifiedBy;
              delete a.modifiedById;
              delete a.order;
              delete a.triggerId;
            });
          }
        });
      }

      if (val.lookups) {
        val.lookups.forEach(l => {
          delete l.id;
          delete l.created;
          delete l.modified;
          delete l.modifiedBy;
          delete l.modifiedById;
          delete l.profileId;
        });
      }      

      if (val.assetProfiles) delete val.assetProfiles;

      return val;
    },
    removeProfile(id) {
      if (this.profiles.find(x => x.id == id)) {
        this.$http
          .delete("api/identityprofiles/" + id)
          .then(request => {
            if (request.status == 200) {
              this.getProfiles();
            }
          })
          .catch((e) => {
            this.$root.$children[0].$emit("display-error", "2700", e);
          });
      }
    },
    importProfile() {
      var u = document.createElement("input");
      u.type = "file";
      u.accept = "application/json";
      u.click();
      const self = this;
      u.onchange = function(evt) {
        try {
          let files = evt.target.files;
          if (!files.length) {
            alert("No file selected!");
            return;
          }
          let file = files[0];
          let reader = new FileReader();
          reader.onload = (self => {
            return event => {
              var importedProfile = self.parseUploadedProfile(
                JSON.parse(event.target.result)
              );

              if (self.profiles.find(x => x.name == importedProfile.name)) {
                importedProfile.name =
                  importedProfile.name +
                  " (" +
                  self.profiles.filter(x => x.name == importedProfile.name)
                    .length +
                  ")";
              }

              self.profiles.push(importedProfile);
              self.selectedProfile = self.profiles[self.profiles.length - 1];
            };
          })(self);
          reader.readAsText(file);
        } catch (e) {
          this.$root.$children[0].$emit("display-error", "2701", e);
        }
      };
    },
    exportProfile(id) {
      var profile = this.profiles.find(x => x.id == id);

      var content = JSON.stringify(this.parseUploadedProfile(profile));
      var filename = profile.name + ".json";
      if (content) {
        var a = document.createElement("a");
        var file = new Blob([content], { type: "text/plain" });
        a.href = URL.createObjectURL(file);
        a.download = filename;
        a.click();
      }
    },
    getProfiles() {
      this.selectedProfile = null;
      this.loading = true;
      this.$http
        .get("api/identityprofiles")
        .then(request => {
          this.profiles = request.data;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$root.$children[0].$emit("display-error", "2702", e);
        });
    },
    addProfile() {
      this.profiles.push({
        name: "",
        steps: [],
        assetProfiles: [],
        triggers: []
      });
      this.selectedProfile = this.profiles[this.profiles.length - 1];
    }
  },
  mounted() {
    this.getProfiles();
  }
};
</script>